import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import { listArticles, ArticleListItem } from "#/services/articles";

export function useArticlesList() {
  return useQuery<ArticleListItem[]>({
    queryKey: qk.articles(),
    queryFn: ({ signal }) => listArticles({ signal }),
    staleTime: 30_000,
  });
}

export default useArticlesList;
